import { check_types, chart_types } from "data/Spec";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import React from "react";

import ChartBox from "./ChartBox.js";

function ChartView() {
  const intl = useIntl();
  const { listType, checkType } = useParams();
  var title = ""
  var check_type = checkType
  if(!check_type) {
    check_type = "ds"
  }
  if (!check_types[check_type]) {
    return (
      <div>not support check_type:{check_type}</div>
    );
  }
  if (chart_types[listType]) {
    let v = chart_types[listType];
    title = intl.formatMessage({ id: v.title_id });
    return <ChartBox ltype={listType} title={title} check_type={check_type}/>;
  }
  if (listType === "all") {
    title = intl.formatMessage({ id: "app.all" });
    return <ChartBox ltype={listType} title={title} check_type={check_type}/>;
  }
  return (
    <div>not support list_type{listType}</div>
  );
}
export default ChartView;
 